import { ApplicationState, AppThunkDispatch } from "../../store";
import { connect } from "react-redux";
import ClientForm  from "../../components/Forms/ClientForm";
import { getMyUser } from "../../store/session/selectors";
import { PermissionEnum } from "../../models";
import { ClientEntity } from "../../store/entities/state";
import { isSubmitting, getChangeLog, getChangingValue, getChangingState } from "../../store/entities/selectors";
import { entityEditionCancel, updateEntity, loadEntityChangeLog, updateChangingEntity, serverCall, loadEntities, deleteEntity, openClientPage } from "../../store/entities/actions";
import { updateClientAsync, getClientChangeLogAsync, postClientResetPasswordAsync, getClientAsync, deleteClientAsync } from "../../ajax/requests";
import { ClientFormDispatchProps, ClientFormStateProps } from "../../components/Forms/ClientForm/ClientForm";
import { TK } from "../../store/translations/translationKeys";

const canEdit = (state: ApplicationState) => getMyUser(state)?.permissions.some(p => p === PermissionEnum.Administrator || p === PermissionEnum.ClientsManagement) || false;

export interface ClientFormProps {
    data: ClientEntity,
    onClose?: () => void,
}

const mapStateToProps = (state: ApplicationState, ownProps: ClientFormProps): ClientFormStateProps => ({
    type: 'edit',
    canManageClients: canEdit(state),
    data: getChangingValue(state, 'clients') as ClientEntity || ownProps.data,
    hasChanged: getChangingState(state, 'clients'),
    isSubmitting: isSubmitting('clients')(state),
    changeLog: getChangeLog(state, 'clients', ownProps.data.id),
})

const mapDispatchToProps = (dispatch: AppThunkDispatch, ownProps: ClientFormProps): ClientFormDispatchProps => ({
    onChange: (data: ClientEntity) => dispatch(updateChangingEntity('clients', data)),
    onCancel: () => {
        dispatch(entityEditionCancel('clients'));
        ownProps.onClose && ownProps.onClose();
    },
    onSave: (data: ClientEntity) => dispatch(updateEntity('clients', data, c => updateClientAsync(c.id, c)))
        .then(_ => {
            // Only close if update was successful
            ownProps.onClose && ownProps.onClose();
        })
        .catch(error => {
            // Error is already handled by updateEntity action, just prevent closing
            console.error('Failed to update client:', error);
        }),
    onDelete: (migrateToClientId?: string) => {
        dispatch(deleteEntity('clients', ownProps.data.id, () => deleteClientAsync(ownProps.data.id, migrateToClientId)))
            .then(_ => {
                ownProps.onClose && ownProps.onClose();
            })
            .catch(error => {
                console.error('Failed to delete client:', error);
            });
    },
    onLoad: () => {
        dispatch(loadEntities('clients', () => getClientAsync(ownProps.data.id), 'AppendResult'))
        dispatch(loadEntityChangeLog('clients', ownProps.data.id, () => getClientChangeLogAsync(ownProps.data.id)));
    },
    onResetClientPassword: (data: ClientEntity) => {
        dispatch(serverCall(() => postClientResetPasswordAsync(data.id), TK.resetPasswordEmailSent))
    },
    onOpenClient: () => {
        dispatch(entityEditionCancel('clients'));
        dispatch(openClientPage(ownProps.data.id));
    },
});

export default connect<ClientFormStateProps, ClientFormDispatchProps, ClientFormProps, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(ClientForm as any);
